/**
 * - Remove protocol from url
 * - Remove trailing slash
 * @param url 
 * @returns 
 */
export default function cleanUrl(url?: string) {
  if (!url) return url;
  return url.replace(/(^\w+:|^)\/\//, "").replace(/\/+$/, "");
}
